/*
 * File: d:\projects\AutoFiFront\src\Theme\Component\PhoneMenu.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Tuesday February 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Tuesday February 21st 2023 10:25:23 am
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { getThemeColor } from "Utils/ThemeColor";
import styled from "styled-components";

const PhoneMenu = styled.div.attrs((props: any) => ({
    bgColor: props.bgColor,
    className: props.className
}))`
position: relative;
bottom: 40%;
right: 0%;
z-index: 20;
width: 650px;
height: 480px;
background: radial-gradient(circle, ${(props: any) => getThemeColor(props.bgColor)};
border-radius: 50%;
transition: 0.3s ease;
transform: translate(0%,-18%);
`;

export default PhoneMenu;
